import { render, staticRenderFns } from "./ThirdPartyIntegrationModal.vue?vue&type=template&id=522b84d9&scoped=true&"
import script from "./ThirdPartyIntegrationModal.vue?vue&type=script&lang=js&"
export * from "./ThirdPartyIntegrationModal.vue?vue&type=script&lang=js&"
import style0 from "./ThirdPartyIntegrationModal.vue?vue&type=style&index=0&id=522b84d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b84d9",
  null
  
)

export default component.exports